import { TFunction } from "i18next";

export const countryCodes = {
  AF: "AF",
  AX: "AX",
  AL: "AL",
  DZ: "DZ",
  AS: "AS",
  AD: "AD",
  AO: "AO",
  AI: "AI",
  AQ: "AQ",
  AG: "AG",
  AR: "AR",
  AM: "AM",
  AW: "AW",
  AU: "AU",
  AT: "AT",
  AZ: "AZ",
  BS: "BS",
  BH: "BH",
  BD: "BD",
  BB: "BB",
  BY: "BY",
  BE: "BE",
  BZ: "BZ",
  BJ: "BJ",
  BM: "BM",
  BT: "BT",
  BO: "BO",
  BQ: "BQ",
  BA: "BA",
  BW: "BW",
  BV: "BV",
  BR: "BR",
  IO: "IO",
  BN: "BN",
  BG: "BG",
  BF: "BF",
  BI: "BI",
  CV: "CV",
  KH: "KH",
  CM: "CM",
  CA: "CA",
  IC: "IC",
  KY: "KY",
  CF: "CF",
  TD: "TD",
  CL: "CL",
  CN: "CN",
  CX: "CX",
  CC: "CC",
  CO: "CO",
  KM: "KM",
  CG: "CG",
  CD: "CD",
  CK: "CK",
  CR: "CR",
  CI: "CI",
  HR: "HR",
  CU: "CU",
  CW: "CW",
  CY: "CY",
  CZ: "CZ",
  DK: "DK",
  DJ: "DJ",
  DM: "DM",
  DO: "DO",
  EC: "EC",
  EG: "EG",
  SV: "SV",
  GQ: "GQ",
  ER: "ER",
  EE: "EE",
  SZ: "SZ",
  ET: "ET",
  FK: "FK",
  FO: "FO",
  FJ: "FJ",
  FI: "FI",
  FR: "FR",
  GF: "GF",
  PF: "PF",
  TF: "TF",
  GA: "GA",
  GM: "GM",
  GE: "GE",
  DE: "DE",
  GH: "GH",
  GI: "GI",
  GR: "GR",
  GL: "GL",
  GD: "GD",
  GP: "GP",
  GU: "GU",
  GT: "GT",
  GG: "GG",
  GN: "GN",
  GW: "GW",
  GY: "GY",
  HT: "HT",
  HM: "HM",
  VA: "VA",
  HN: "HN",
  HK: "HK",
  HU: "HU",
  IS: "IS",
  IN: "IN",
  ID: "ID",
  IR: "IR",
  IQ: "IQ",
  IE: "IE",
  IM: "IM",
  IL: "IL",
  IT: "IT",
  JM: "JM",
  JP: "JP",
  JE: "JE",
  JO: "JO",
  KZ: "KZ",
  KE: "KE",
  KI: "KI",
  KP: "KP",
  KR: "KR",
  XK: "XK",
  KW: "KW",
  KG: "KG",
  LA: "LA",
  LV: "LV",
  LB: "LB",
  LS: "LS",
  LR: "LR",
  LY: "LY",
  LI: "LI",
  LT: "LT",
  LU: "LU",
  MO: "MO",
  MK: "MK",
  MG: "MG",
  MW: "MW",
  MY: "MY",
  MV: "MV",
  ML: "ML",
  MT: "MT",
  MH: "MH",
  MQ: "MQ",
  MR: "MR",
  MU: "MU",
  YT: "YT",
  MX: "MX",
  FM: "FM",
  MD: "MD",
  MC: "MC",
  MN: "MN",
  ME: "ME",
  MS: "MS",
  MA: "MA",
  MZ: "MZ",
  MM: "MM",
  NA: "NA",
  NR: "NR",
  NP: "NP",
  NL: "NL",
  NC: "NC",
  NZ: "NZ",
  NI: "NI",
  NE: "NE",
  NG: "NG",
  NU: "NU",
  NF: "NF",
  MP: "MP",
  NO: "NO",
  OM: "OM",
  PK: "PK",
  PW: "PW",
  PS: "PS",
  PA: "PA",
  PG: "PG",
  PY: "PY",
  PE: "PE",
  PH: "PH",
  PN: "PN",
  PL: "PL",
  PT: "PT",
  PR: "PR",
  QA: "QA",
  RE: "RE",
  RO: "RO",
  RU: "RU",
  RW: "RW",
  BL: "BL",
  SH: "SH",
  KN: "KN",
  LC: "LC",
  MF: "MF",
  PM: "PM",
  VC: "VC",
  WS: "WS",
  SM: "SM",
  ST: "ST",
  SA: "SA",
  SN: "SN",
  RS: "RS",
  SC: "SC",
  SL: "SL",
  SG: "SG",
  SX: "SX",
  SK: "SK",
  SI: "SI",
  SB: "SB",
  SO: "SO",
  ZA: "ZA",
  GS: "GS",
  SS: "SS",
  ES: "ES",
  LK: "LK",
  SD: "SD",
  SR: "SR",
  SJ: "SJ",
  SE: "SE",
  CH: "CH",
  SY: "SY",
  TW: "TW",
  TJ: "TJ",
  TZ: "TZ",
  TH: "TH",
  TL: "TL",
  TG: "TG",
  TK: "TK",
  TO: "TO",
  TT: "TT",
  TN: "TN",
  TR: "TR",
  TM: "TM",
  TC: "TC",
  TV: "TV",
  UG: "UG",
  UA: "UA",
  AE: "AE",
  GB: "GB",
  UM: "UM",
  US: "US",
  UY: "UY",
  UZ: "UZ",
  VU: "VU",
  VE: "VE",
  VN: "VN",
  VG: "VG",
  VI: "VI",
  WF: "WF",
  EH: "EH",
  YE: "YE",
  ZM: "ZM",
  ZW: "ZW",
} as const;

export type CountryCode = (typeof countryCodes)[keyof typeof countryCodes];

export const restrictedCountryCodes: CountryCode[] = [
  "AF",
  "AS",
  "AQ",
  "AM",
  "BY",
  "BE",
  "BZ",
  "BT",
  "BA",
  "BI",
  "CM",
  "CA",
  "CF",
  "TD",
  "CD",
  "CG",
  "CI",
  "ER",
  "GU",
  "GN",
  "GW",
  "GY",
  "HT",
  "VA",
  "IR",
  "IQ",
  "JP",
  "KZ",
  "LB",
  "LR",
  "LY",
  "ML",
  "MZ",
  "MM",
  "NZ",
  "NI",
  "KP",
  "PS",
  "PR",
  "RU",
  "KN",
  "LC",
  "VC",
  "WS",
  "SO",
  "GS",
  "KR",
  "SS",
  "SD",
  "SR",
  "SY",
  "TJ",
  "TN",
  "TM",
  "TC",
  "UA",
  "US",
  "VU",
  "VE",
  "VI",
  "EH",
  "YE",
  "ZW",
] as const;

export const ibJourney1Countries: CountryCode[] = [
  "AT",
  "DE",
  "DZ",
  "AO",
  "BS",
  "BJ",
  "BW",
  "BF",
  "CV",
  "KM",
  "CU",
  "DJ",
  "GQ",
  "SZ",
  "GA",
  "GM",
  "GH",
  "IL",
  "KE",
  "LS",
  "MG",
  "MW",
  "MR",
  "MU",
  "NA",
  "NE",
  "NG",
  "RW",
  "SH",
  "ST",
  "SN",
  "SC",
  "SL",
  "ZA",
  "TZ",
  "TG",
  "UG",
  "ZM",
  "AE",
  "AI",
  "AG",
  "AR",
  "AW",
  "AZ",
  "BH",
  "BD",
  "BB",
  "BM",
  "BO",
  "BQ",
  "BR",
  "VG",
  "BN",
  "KH",
  "KY",
  "CL",
  "CN",
  "CX",
  "CO",
  "CK",
  "CR",
  "CW",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "ET",
  "FK",
  "FJ",
  "GE",
  "GL",
  "GD",
  "GT",
  "HN",
  "HK",
  "IN",
  "ID",
  "JM",
  "JO",
  "KI",
  "KW",
  "KG",
  "LA",
  "MO",
  "MY",
  "MV",
  "MH",
  "MX",
  "FM",
  "MN",
  "MS",
  "MA",
  "NR",
  "NP",
  "NU",
  "MP",
  "OM",
  "PK",
  "PW",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "QA",
  "SA",
  "SG",
  "SB",
  "LK",
  "TW",
  "TH",
  "TL",
  "TK",
  "TO",
  "TT",
  "TR",
  "TV",
  "UY",
  "UZ",
  "VN",
] as const;

export const ibJourney2Countries: CountryCode[] = [
  "AX",
  "BG",
  "IC",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "GF",
  "PF",
  "GR",
  "GP",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "MQ",
  "YT",
  "NL",
  "NC",
  "NO",
  "PL",
  "PT",
  "RE",
  "RO",
  "BL",
  "MF",
  "PM",
  "RS",
  "SX",
  "SK",
  "SI",
  "ES",
  "SJ",
  "SE",
  "WF",
  "AL",
  "AD",
  "IO",
  "FO",
  "GI",
  "GG",
  "IM",
  "JE",
  "XK",
  "MD",
  "MC",
  "ME",
  "MK",
  "SM",
  "CH",
  "GB",
] as const;

export const ibJourney3Countries: CountryCode[] = ["AU"] as const;

export const affiliateJourney1Countries: CountryCode[] = [
  "DZ",
  "AO",
  "BS",
  "BJ",
  "BW",
  "BF",
  "CV",
  "KM",
  "CU",
  "DJ",
  "GQ",
  "SZ",
  "GA",
  "GM",
  "GH",
  "IL",
  "KE",
  "LS",
  "MG",
  "MW",
  "MR",
  "MU",
  "NA",
  "NE",
  "NG",
  "RW",
  "SH",
  "ST",
  "SN",
  "SC",
  "SL",
  "ZA",
  "TZ",
  "TG",
  "UG",
  "ZM",
  "AI",
  "AG",
  "AR",
  "AW",
  "AZ",
  "BH",
  "BD",
  "BB",
  "BM",
  "BO",
  "BQ",
  "BR",
  "VG",
  "BN",
  "KH",
  "KY",
  "CL",
  "CN",
  "CX",
  "CO",
  "CK",
  "CR",
  "CW",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "ET",
  "FK",
  "FJ",
  "GE",
  "GL",
  "GD",
  "GT",
  "HN",
  "HK",
  "IN",
  "ID",
  "JM",
  "JO",
  "KI",
  "KW",
  "KG",
  "LA",
  "MO",
  "MY",
  "MV",
  "MH",
  "MX",
  "FM",
  "MN",
  "MS",
  "MA",
  "NR",
  "NP",
  "NU",
  "MP",
  "OM",
  "PK",
  "PW",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "QA",
  "SA",
  "SG",
  "SB",
  "LK",
  "TW",
  "TH",
  "TL",
  "TK",
  "TO",
  "TT",
  "TR",
  "TV",
  "UY",
  "UZ",
  "VN",
] as const;

export const affiliateJourney2Countries: CountryCode[] = ["AU", "AE"] as const;

export const affiliateJourney3Countries: CountryCode[] = [
  "AX",
  "AL",
  "AD",
  "AT",
  "IO",
  "BG",
  "IC",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FO",
  "FI",
  "FR",
  "GF",
  "PF",
  "DE",
  "GI",
  "GR",
  "GP",
  "GG",
  "HU",
  "IS",
  "IE",
  "IM",
  "IT",
  "JE",
  "XK",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "MQ",
  "YT",
  "MD",
  "MC",
  "ME",
  "NL",
  "NC",
  "MK",
  "NO",
  "PL",
  "PT",
  "RE",
  "RO",
  "BL",
  "MF",
  "PM",
  "SM",
  "RS",
  "SX",
  "SK",
  "SI",
  "ES",
  "SJ",
  "SE",
  "CH",
  "GB",
  "WF",
] as const;

export const mamJourney1Countries: CountryCode[] = [
  "DZ",
  "AO",
  "BS",
  "BJ",
  "BW",
  "BF",
  "CV",
  "KM",
  "CU",
  "DJ",
  "GQ",
  "SZ",
  "GA",
  "GM",
  "GH",
  "IL",
  "KE",
  "LS",
  "MG",
  "MW",
  "MR",
  "MU",
  "NA",
  "NE",
  "NG",
  "RW",
  "SH",
  "ST",
  "SN",
  "SC",
  "SL",
  "ZA",
  "TZ",
  "TG",
  "UG",
  "ZM",
  "AI",
  "AG",
  "AR",
  "AW",
  "AZ",
  "BH",
  "BD",
  "BB",
  "BM",
  "BO",
  "BQ",
  "BR",
  "VG",
  "BN",
  "KH",
  "KY",
  "CL",
  "CN",
  "CX",
  "CO",
  "CK",
  "CR",
  "CW",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "ET",
  "FK",
  "FJ",
  "GE",
  "GL",
  "GD",
  "GT",
  "HN",
  "HK",
  "IN",
  "ID",
  "JM",
  "JO",
  "KI",
  "KW",
  "KG",
  "LA",
  "MO",
  "MY",
  "MV",
  "MH",
  "MX",
  "FM",
  "MN",
  "MS",
  "MA",
  "NR",
  "NP",
  "NU",
  "MP",
  "OM",
  "PK",
  "PW",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "QA",
  "SA",
  "SG",
  "SB",
  "LK",
  "TW",
  "TH",
  "TL",
  "TK",
  "TO",
  "TT",
  "TR",
  "TV",
  "UY",
  "UZ",
  "VN",
] as const;

export const mamJourney2Countries: CountryCode[] = [
  "AU",
  "AT",
  "DE",
  "AX",
  "BG",
  "IC",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "GF",
  "PF",
  "GR",
  "GP",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "MQ",
  "YT",
  "NL",
  "NC",
  "NO",
  "PL",
  "PT",
  "RE",
  "RO",
  "BL",
  "MF",
  "PM",
  "RS",
  "SX",
  "SK",
  "SI",
  "ES",
  "SJ",
  "SE",
  "WF",
  "AE",
  "AL",
  "AD",
  "IO",
  "FO",
  "GI",
  "GG",
  "IM",
  "JE",
  "XK",
  "MD",
  "MC",
  "ME",
  "MK",
  "SM",
  "CH",
  "GB",
] as const;

export const buildCountryCodeMapping = (
  t: TFunction<"translation", undefined>,
) =>
  new Map<CountryCode, string>([
    ["AF", t("global_countryName_af")],
    ["AX", t("global_countryName_ax")],
    ["AL", t("global_countryName_al")],
    ["DZ", t("global_countryName_dz")],
    ["AS", t("global_countryName_as")],
    ["AD", t("global_countryName_ad")],
    ["AO", t("global_countryName_ao")],
    ["AI", t("global_countryName_ai")],
    ["AQ", t("global_countryName_aq")],
    ["AG", t("global_countryName_ag")],
    ["AR", t("global_countryName_ar")],
    ["AM", t("global_countryName_am")],
    ["AW", t("global_countryName_aw")],
    ["AU", t("global_countryName_au")],
    ["AT", t("global_countryName_at")],
    ["AZ", t("global_countryName_az")],
    ["BS", t("global_countryName_bs")],
    ["BH", t("global_countryName_bh")],
    ["BD", t("global_countryName_bd")],
    ["BB", t("global_countryName_bb")],
    ["BY", t("global_countryName_by")],
    ["BE", t("global_countryName_be")],
    ["BZ", t("global_countryName_bz")],
    ["BJ", t("global_countryName_bj")],
    ["BM", t("global_countryName_bm")],
    ["BT", t("global_countryName_bt")],
    ["BO", t("global_countryName_bo")],
    ["BQ", t("global_countryName_bq")],
    ["BA", t("global_countryName_ba")],
    ["BW", t("global_countryName_bw")],
    ["BV", t("global_countryName_bv")],
    ["BR", t("global_countryName_br")],
    ["IO", t("global_countryName_io")],
    ["BN", t("global_countryName_bn")],
    ["BG", t("global_countryName_bg")],
    ["BF", t("global_countryName_bf")],
    ["BI", t("global_countryName_bi")],
    ["CV", t("global_countryName_cv")],
    ["KH", t("global_countryName_kh")],
    ["CM", t("global_countryName_cm")],
    ["CA", t("global_countryName_ca")],
    ["IC", t("global_countryName_ic")],
    ["KY", t("global_countryName_ky")],
    ["CF", t("global_countryName_cf")],
    ["TD", t("global_countryName_td")],
    ["CL", t("global_countryName_cl")],
    ["CN", t("global_countryName_cn")],
    ["CX", t("global_countryName_cx")],
    ["CC", t("global_countryName_cc")],
    ["CO", t("global_countryName_co")],
    ["KM", t("global_countryName_km")],
    ["CG", t("global_countryName_cg")],
    ["CD", t("global_countryName_cd")],
    ["CK", t("global_countryName_ck")],
    ["CR", t("global_countryName_cr")],
    ["CI", t("global_countryName_ci")],
    ["HR", t("global_countryName_hr")],
    ["CU", t("global_countryName_cu")],
    ["CW", t("global_countryName_cw")],
    ["CY", t("global_countryName_cy")],
    ["CZ", t("global_countryName_cz")],
    ["DK", t("global_countryName_dk")],
    ["DJ", t("global_countryName_dj")],
    ["DM", t("global_countryName_dm")],
    ["DO", t("global_countryName_do")],
    ["EC", t("global_countryName_ec")],
    ["EG", t("global_countryName_eg")],
    ["SV", t("global_countryName_sv")],
    ["GQ", t("global_countryName_gq")],
    ["ER", t("global_countryName_er")],
    ["EE", t("global_countryName_ee")],
    ["SZ", t("global_countryName_sz")],
    ["ET", t("global_countryName_et")],
    ["FK", t("global_countryName_fk")],
    ["FO", t("global_countryName_fo")],
    ["FJ", t("global_countryName_fj")],
    ["FI", t("global_countryName_fi")],
    ["FR", t("global_countryName_fr")],
    ["GF", t("global_countryName_gf")],
    ["PF", t("global_countryName_pf")],
    ["TF", t("global_countryName_tf")],
    ["GA", t("global_countryName_ga")],
    ["GM", t("global_countryName_gm")],
    ["GE", t("global_countryName_ge")],
    ["DE", t("global_countryName_de")],
    ["GH", t("global_countryName_gh")],
    ["GI", t("global_countryName_gi")],
    ["GR", t("global_countryName_gr")],
    ["GL", t("global_countryName_gl")],
    ["GD", t("global_countryName_gd")],
    ["GP", t("global_countryName_gp")],
    ["GU", t("global_countryName_gu")],
    ["GT", t("global_countryName_gt")],
    ["GG", t("global_countryName_gg")],
    ["GN", t("global_countryName_gn")],
    ["GW", t("global_countryName_gw")],
    ["GY", t("global_countryName_gy")],
    ["HT", t("global_countryName_ht")],
    ["HM", t("global_countryName_hm")],
    ["VA", t("global_countryName_va")],
    ["HN", t("global_countryName_hn")],
    ["HK", t("global_countryName_hk")],
    ["HU", t("global_countryName_hu")],
    ["IS", t("global_countryName_is")],
    ["IN", t("global_countryName_in")],
    ["ID", t("global_countryName_id")],
    ["IR", t("global_countryName_ir")],
    ["IQ", t("global_countryName_iq")],
    ["IE", t("global_countryName_ie")],
    ["IM", t("global_countryName_im")],
    ["IL", t("global_countryName_il")],
    ["IT", t("global_countryName_it")],
    ["JM", t("global_countryName_jm")],
    ["JP", t("global_countryName_jp")],
    ["JE", t("global_countryName_je")],
    ["JO", t("global_countryName_jo")],
    ["KZ", t("global_countryName_kz")],
    ["KE", t("global_countryName_ke")],
    ["KI", t("global_countryName_ki")],
    ["KP", t("global_countryName_kp")],
    ["KR", t("global_countryName_kr")],
    ["XK", t("global_countryName_xk")],
    ["KW", t("global_countryName_kw")],
    ["KG", t("global_countryName_kg")],
    ["LA", t("global_countryName_la")],
    ["LV", t("global_countryName_lv")],
    ["LB", t("global_countryName_lb")],
    ["LS", t("global_countryName_ls")],
    ["LR", t("global_countryName_lr")],
    ["LY", t("global_countryName_ly")],
    ["LI", t("global_countryName_li")],
    ["LT", t("global_countryName_lt")],
    ["LU", t("global_countryName_lu")],
    ["MO", t("global_countryName_mo")],
    ["MK", t("global_countryName_mk")],
    ["MG", t("global_countryName_mg")],
    ["MW", t("global_countryName_mw")],
    ["MY", t("global_countryName_my")],
    ["MV", t("global_countryName_mv")],
    ["ML", t("global_countryName_ml")],
    ["MT", t("global_countryName_mt")],
    ["MH", t("global_countryName_mh")],
    ["MQ", t("global_countryName_mq")],
    ["MR", t("global_countryName_mr")],
    ["MU", t("global_countryName_mu")],
    ["YT", t("global_countryName_yt")],
    ["MX", t("global_countryName_mx")],
    ["FM", t("global_countryName_fm")],
    ["MD", t("global_countryName_md")],
    ["MC", t("global_countryName_mc")],
    ["MN", t("global_countryName_mn")],
    ["ME", t("global_countryName_me")],
    ["MS", t("global_countryName_ms")],
    ["MA", t("global_countryName_ma")],
    ["MZ", t("global_countryName_mz")],
    ["MM", t("global_countryName_mm")],
    ["NA", t("global_countryName_na")],
    ["NR", t("global_countryName_nr")],
    ["NP", t("global_countryName_np")],
    ["NL", t("global_countryName_nl")],
    ["NC", t("global_countryName_nc")],
    ["NZ", t("global_countryName_nz")],
    ["NI", t("global_countryName_ni")],
    ["NE", t("global_countryName_ne")],
    ["NG", t("global_countryName_ng")],
    ["NU", t("global_countryName_nu")],
    ["NF", t("global_countryName_nf")],
    ["MP", t("global_countryName_mp")],
    ["NO", t("global_countryName_no")],
    ["OM", t("global_countryName_om")],
    ["PK", t("global_countryName_pk")],
    ["PW", t("global_countryName_pw")],
    ["PS", t("global_countryName_ps")],
    ["PA", t("global_countryName_pa")],
    ["PG", t("global_countryName_pg")],
    ["PY", t("global_countryName_py")],
    ["PE", t("global_countryName_pe")],
    ["PH", t("global_countryName_ph")],
    ["PN", t("global_countryName_pn")],
    ["PL", t("global_countryName_pl")],
    ["PT", t("global_countryName_pt")],
    ["PR", t("global_countryName_pr")],
    ["QA", t("global_countryName_qa")],
    ["RE", t("global_countryName_re")],
    ["RO", t("global_countryName_ro")],
    ["RU", t("global_countryName_ru")],
    ["RW", t("global_countryName_rw")],
    ["BL", t("global_countryName_bl")],
    ["SH", t("global_countryName_sh")],
    ["KN", t("global_countryName_kn")],
    ["LC", t("global_countryName_lc")],
    ["MF", t("global_countryName_mf")],
    ["PM", t("global_countryName_pm")],
    ["VC", t("global_countryName_vc")],
    ["WS", t("global_countryName_ws")],
    ["SM", t("global_countryName_sm")],
    ["ST", t("global_countryName_st")],
    ["SA", t("global_countryName_sa")],
    ["SN", t("global_countryName_sn")],
    ["RS", t("global_countryName_rs")],
    ["SC", t("global_countryName_sc")],
    ["SL", t("global_countryName_sl")],
    ["SG", t("global_countryName_sg")],
    ["SX", t("global_countryName_sx")],
    ["SK", t("global_countryName_sk")],
    ["SI", t("global_countryName_si")],
    ["SB", t("global_countryName_sb")],
    ["SO", t("global_countryName_so")],
    ["ZA", t("global_countryName_za")],
    ["GS", t("global_countryName_gs")],
    ["SS", t("global_countryName_ss")],
    ["ES", t("global_countryName_es")],
    ["LK", t("global_countryName_lk")],
    ["SD", t("global_countryName_sd")],
    ["SR", t("global_countryName_sr")],
    ["SJ", t("global_countryName_sj")],
    ["SE", t("global_countryName_se")],
    ["CH", t("global_countryName_ch")],
    ["SY", t("global_countryName_sy")],
    ["TW", t("global_countryName_tw")],
    ["TJ", t("global_countryName_tj")],
    ["TZ", t("global_countryName_tz")],
    ["TH", t("global_countryName_th")],
    ["TL", t("global_countryName_tl")],
    ["TG", t("global_countryName_tg")],
    ["TK", t("global_countryName_tk")],
    ["TO", t("global_countryName_to")],
    ["TT", t("global_countryName_tt")],
    ["TN", t("global_countryName_tn")],
    ["TR", t("global_countryName_tr")],
    ["TM", t("global_countryName_tm")],
    ["TC", t("global_countryName_tc")],
    ["TV", t("global_countryName_tv")],
    ["UG", t("global_countryName_ug")],
    ["UA", t("global_countryName_ua")],
    ["AE", t("global_countryName_ae")],
    ["GB", t("global_countryName_gb")],
    ["UM", t("global_countryName_um")],
    ["US", t("global_countryName_us")],
    ["UY", t("global_countryName_uy")],
    ["UZ", t("global_countryName_uz")],
    ["VU", t("global_countryName_vu")],
    ["VE", t("global_countryName_ve")],
    ["VN", t("global_countryName_vn")],
    ["VG", t("global_countryName_vg")],
    ["VI", t("global_countryName_vi")],
    ["WF", t("global_countryName_wf")],
    ["EH", t("global_countryName_eh")],
    ["YE", t("global_countryName_ye")],
    ["ZM", t("global_countryName_zm")],
    ["ZW", t("global_countryName_zw")],
  ]);
